module.exports = __webpack_public_path__ + "files/c472b57029cc804912e0380dcbf72491.woff2";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Script-Regular.woff2
// module id = 977
// module chunks = 60